var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashTop2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666626,
    width: 54,
    height: 54,
    rx: 8,
    fill: "#FFEDD5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4166 29.5V37M36.4166 37L38.9166 34.5M36.4166 37L33.9166 34.5",
    stroke: "#EA580C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1666 27C40.1666 22.286 40.1666 19.9289 38.7022 18.4645C37.2377 17 34.8807 17 30.1666 17H25.1666C20.4526 17 18.0956 17 16.6311 18.4645C15.1666 19.9289 15.1666 22.286 15.1666 27C15.1666 31.714 15.1666 34.0711 16.6311 35.5355C18.0956 37 20.4526 37 25.1666 37H30.1666",
    stroke: "#EA580C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1666 32H20.1666",
    stroke: "#EA580C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9166 32H28.2916",
    stroke: "#EA580C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1666 24.5L40.1666 24.5",
    stroke: "#EA580C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashTop2);
export default __webpack_public_path__ + "static/media/dash-top-2.fbad38b6fbf9205772d98b237080c583.svg";
export { ForwardRef as ReactComponent };